module.exports = function() {
  return new Worker(__webpack_public_path__ + "32948d7976a24ebcdb5f.worker.js");
};